import { useId } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, MODAL_SIZES } from 'ui/modal';
import { Body2 } from 'ui/theme';
import { SecondaryButton, PrimaryButton } from 'ui/button';

type ExportReportModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  exportAction: () => void;
  saveAndExportAction: () => void;
};

export const ExportReportModal = ({
  isOpen,
  closeModal,
  exportAction,
  saveAndExportAction,
}: ExportReportModalProps) => {
  const modalId = useId();

  const handleExport = () => {
    closeModal();
    exportAction();
  };

  const handleSaveAndExport = () => {
    saveAndExportAction();
    closeModal();
  };
  return isOpen ? (
    <Modal id={modalId} isModalOpen={isOpen} onClose={closeModal} size={MODAL_SIZES.SMALL}>
      <ModalHeader>Save changes before export?</ModalHeader>
      <ModalBody>
        <Body2>There are unsaved changes to the metrics selected for this report.</Body2>
        <Body2>
          Metric that are selected will not be included in your report when you click
          &quot;Export&quot;. You can save those changes by clicking &quot;Save and Export&quot;.
        </Body2>
      </ModalBody>
      <ModalFooter onClose={closeModal}>
        <SecondaryButton onClick={handleExport} data-test="exportReportAsCsvButton">
          Export
        </SecondaryButton>
        <PrimaryButton onClick={handleSaveAndExport} data-test="saveAndExportReportAsCsvButton">
          Save and Export
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  ) : null;
};
